import React from 'react';
import { Theme } from '@app/theme';
import { createUseStyles, useTheme } from 'react-jss';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  iconContainer: {
    background: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: theme.marginBase * 5,
    height: theme.marginBase * 5,
    cursor: 'pointer',
    position: 'relative',
    borderRadius: theme.borderRadius.std,
  },
  icon: {
    fontSize: theme.iconSize.large,
    color: theme.colors.grayBorder,
  },
}));

interface Props {
  icon: string;
  href?: string;
}

export const NavbarHref = ({ icon, href, ...rest }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  return (
    <a
      href={href}
      className={classes.iconContainer}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      <i className={classnames(icon, classes.icon)} />
    </a>
  );
};
